Ext.define('SA.model.LocationValue.EphemeralRadius', {
    extend: 'SA.model.LocationValue',

    statics: {
        isConformantValue(value) {
            var object = SA.Object.of(value);

            return object
                && object.hasType('radius')
                && object.keysAre(['type', 'id', 'locationSeries', 'radius'])
                && object.testProperty('id', value => this.isStringId(value));
        },

        isStringId(value) {
            if (!Ext.isString(value)) {
                return false;
            }

            var parts = value.split('-'),
                [firstPart, secondPart = ''] = parts,
                isNumeric = string => /^\d+(\.\d+)?$/.test(string);

            return parts.length === 2
                && SA.model.LocationValue.isConformantStringValue(firstPart)
                && isNumeric(secondPart);
        }
    },

    toNormalized() {
        var centerLocation = SA.model.LocationValue.for(this.value.locationSeries).toModel(),
            locationSeries = centerLocation.isRadius() ? centerLocation.getCenterLocationId() : centerLocation.getId(),
            radiusSizeInMeters = this.value.radius + (centerLocation.isRadius() ? centerLocation.getRadiusSizeInMeters() : 0);

        return SA.model.NormalizedLocationBuilder
            .forRadius()
            .stringId(`customLocation:${this.value.id}`)
            .locationSeries(locationSeries)
            .radiusSizeInMeters(radiusSizeInMeters)
            .build();
    }
});